import { CorporateProfileService } from "@/api/services/masterService";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Corporate {
  id: string;
  name: string;
}

interface CorporateMaster {
  loading: boolean;
  CorporateList: Corporate[];
  error?: string;
}

const initialState: CorporateMaster = {
  loading: false,
  CorporateList: [],
  error: undefined,
};

export const fetchCorporateMaster = createAsyncThunk<
  Corporate[],
  void,
  { rejectValue: string }
>("Corporate/fetchCorporateMaster", async (_, { rejectWithValue }) => {
  try {
    const response = await CorporateProfileService.getall();
    return response.data;
  } catch (error: any) {
    return rejectWithValue(error.message || "Failed to fetch Corporate data");
  }
});

const CorporateMasterSlice = createSlice({
  name: "CorporateMaster",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchCorporateMaster.pending, (state) => {
      state.loading = true;
      state.error = undefined;
    });
    builder
      .addCase(
        fetchCorporateMaster.fulfilled,
        (state, action: PayloadAction<Corporate[]>) => {
          state.CorporateList = action.payload;
          state.loading = false;
        }
      )
      .addCase(fetchCorporateMaster.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export default CorporateMasterSlice.reducer;
